import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/Users/kellymears/code/projects/cli/bud/bud-sandbox/web/app/themes/wp-react-hooks/node_modules/gatsby-theme-docz/src/base/Layout.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "useselection"
    }}>{`useSelection`}</h1>
    <p>{`The `}<inlineCode parentName="p">{`useSelection`}</inlineCode>{` hook provides a way of consuming and modifying which blocks are currently selected.`}</p>
    <h2 {...{
      "id": "usage"
    }}>{`Usage`}</h2>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`import {useSelection} from '@tinypixelco/wp-react-hooks'
`}</code></pre>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`const {selection, setSelection} = useSelection()
`}</code></pre>
    <h2 {...{
      "id": "selection"
    }}><inlineCode parentName="h2">{`selection`}</inlineCode></h2>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`import {useSelection} from '@tinypixelco/wp-react-hooks'

const component = () => {
  const {selection} = useSelection()

  return (
    <div>
      {selection && JSON.stringify(selection)}
    </div>
  )
}
`}</code></pre>
    <p>{`The `}<inlineCode parentName="p">{`selection`}</inlineCode>{` object looks like this:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`{
  attributes: {}
  clientId: "881d5ee3-1672-4607-8b65-1fa7877adf0d"
  innerBlocks: []
  isValid: true
  name: 'acme-co/acme-block'
}
`}</code></pre>
    <h2 {...{
      "id": "setselection"
    }}>{`setSelection`}</h2>
    <p>{`This block will always be selected.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`import {useSelection} from '@tinypixelco/wp-react-hooks'

const component = ({clientId}) => {
  const {selection, setSelection} = useSelection()

  useEffect(() => {
    const notSelected = selection.clientId !== clientId

    if (notSelected) {
      setSelection(clientId)
    }
  }, [selection])

  return (
    <div>
      Annoyingly, this block is always selected.
    </div>
  )
}
`}</code></pre>
    <p>{`Any actual use of `}<inlineCode parentName="p">{`setSelection`}</inlineCode>{` would likely involve you:`}</p>
    <ul>
      <li parentName="ul">{`Getting the block ID you want to select. There are other hooks in this library which may help.`}</li>
      <li parentName="ul">{`Developing criteria that needs to be met to trigger the selection (our example sidesteps this by just always firing, which is probably not what you want.)`}</li>
      <li parentName="ul">{`Calling `}<inlineCode parentName="li">{`setSelection`}</inlineCode>{` when that criteria is met.`}</li>
    </ul>
    <p>{`But, this example allows us to demonstrate the functionality of the component in isolation.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      